// https://tracker.globetrack.ie/issues/11519 - Admin > AI Setup.
// Backend (#11517) answers these for GT support users only; anyone else gets
// the GraphQL error "Not authorised to manage AI Setup."
import gql from "graphql-tag";

export const AI_SETUP_OWNERS_QUERY = gql`
  query aiSetupOwners {
    owners {
      edges {
        node {
          id
          name
          domain
        }
      }
    }
  }
`;

export const AI_MODULE_REGISTRY_QUERY = gql`
  query aiModuleRegistry {
    aiModuleRegistry {
      key
      label
      models {
        kind
        model
        defaultModel
        overridden
      }
      params {
        key
        type
        default
        min
        max
        options
        optionLabels
        label
        help
      }
    }
  }
`;

const SETTING_FIELDS = `
  module
  label
  domain
  enabled
  monthlyCapUsd
  monthToDateCostUsd
  updatedAt
  updatedByName
  models {
    kind
    model
    defaultModel
    overridden
  }
  params {
    key
    value
    overridden
  }
`;

export const AI_MODULE_SETTINGS_QUERY = gql`
  query aiModuleSettings($domain: String!) {
    aiModuleSettings(domain: $domain) {
      ${SETTING_FIELDS}
    }
  }
`;

// Partial update: only the arguments passed are changed. monthlyCapUsd: null
// clears the cap, a blank model / null param value resets to the default.
export const UPDATE_AI_MODULE_SETTING_MUTATION = gql`
  mutation updateAiModuleSetting(
    $domain: String!
    $module: String!
    $monthlyCapUsd: Float
    $models: [AiModuleModelInput!]
    $params: [AiModuleParamInput!]
  ) {
    updateAiModuleSetting(
      domain: $domain
      module: $module
      monthlyCapUsd: $monthlyCapUsd
      models: $models
      params: $params
    ) {
      ok
      errors {
        field
        message
      }
      setting {
        ${SETTING_FIELDS}
      }
    }
  }
`;

// Param values and defaults travel as JSON strings both ways.
export const parseJsonValue = (s) => {
  if (s === null || s === undefined) return null;
  try {
    return JSON.parse(s);
  } catch (e) {
    return s;
  }
};

// https://tracker.globetrack.ie/issues/11520 - Usage tab (AIS-07). Backend
// (#11518) is GT support only: "You are not authorised to view AI usage".
// from/to are inclusive YYYY-MM-DD dates in the app time zone; the summary
// echoes the dates it used. One request, four groupings via aliases.
const USAGE_ROW_FIELDS = `
  key
  label
  calls
  errors
  cappedCalls
  promptTokens
  completionTokens
  costUsd
`;

export const AI_USAGE_SUMMARY_QUERY = gql`
  query aiUsageDashboard(
    $from: String
    $to: String
    $domain: String
    $module: String
  ) {
    byTenant: aiUsageSummary(
      from: $from
      to: $to
      domain: $domain
      module: $module
      groupBy: TENANT
    ) {
      from
      to
      totals {
        calls
        errors
        cappedCalls
        promptTokens
        completionTokens
        costUsd
      }
      rows {
        ${USAGE_ROW_FIELDS}
      }
    }
    byModule: aiUsageSummary(
      from: $from
      to: $to
      domain: $domain
      module: $module
      groupBy: MODULE
    ) {
      rows {
        ${USAGE_ROW_FIELDS}
      }
    }
    byModel: aiUsageSummary(
      from: $from
      to: $to
      domain: $domain
      module: $module
      groupBy: MODEL
    ) {
      rows {
        ${USAGE_ROW_FIELDS}
      }
    }
    byDay: aiUsageSummary(
      from: $from
      to: $to
      domain: $domain
      module: $module
      groupBy: DAY
    ) {
      rows {
        key
        calls
        costUsd
      }
    }
  }
`;

// Newest first. "Load more" appends the next page via fetchMore(after).
export const AI_USAGE_EVENTS_QUERY = gql`
  query aiUsageEvents(
    $first: Int
    $after: String
    $from: String
    $to: String
    $domain: String
    $module: String
    $onlyErrors: Boolean
  ) {
    aiUsageEvents(
      first: $first
      after: $after
      from: $from
      to: $to
      domain: $domain
      module: $module
      onlyErrors: $onlyErrors
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          createdAt
          domain
          tenantName
          userId
          userName
          aiModule
          moduleLabel
          callName
          kind
          model
          promptTokens
          completionTokens
          costUsd
          ok
          capped
          error
          durationMs
          sourceType
          sourceId
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/gt/admin/ai-setup/ai-setup-graphql.js